import React from 'react';
import { string } from 'prop-types';
import { I18n, translate } from '@fiverr-private/i18n-react';
import { makersExperience } from '@fiverr-private/logo_maker_analytics';
import DiscoverHero from '../../../shared/components/LandingPages/DiscoverHero';
import DesignsByIndustry from '../../../shared/components/LandingPages/DesignsByIndustry';
import DiscoverIdeasMakeYourLogo from '../../../shared/components/LandingPages/DiscoverIdeasMakeYourLogo';
import HowDoesItWork from '../../../shared/components/LandingPages/HowDoesItWork';
import IdeaTags from '../../../shared/components/LandingPages/IdeaTags';
import { SECTION_KEYS } from '../../../shared/components/LandingPages/HowDoesItWork/constants';
import Footer from '../../../shared/components/LandingPages/Footer';
import Teaser from '../../../shared/components/LandingPages/Teaser';
import Breadcrumbs from '../../../shared/components/Breadcrumbs';
import MakeMyLogoButton from '../../../shared/components/MakeMyLogoButton';
import { getBreadcrumbList } from '../../../shared/lib';
import { useEffectOnce } from '../../../shared/hooks';
import monitor from '../../../service/bigquery';
import { POPULAR_KEYWORDS } from '../DiscoverLogoIdeas/constants';
import { HERO_IMG_URL, DESIGNS_BY_INDUSTRY, TEASER_CONTENT, IDEAS_HUB_ACTIONS, IDEAS_HUB_SECTIONS } from './constants';
import './style.scss';

const { reportPageView, reportIdeasHubBtnClicked } = makersExperience.monogramLogoIdeas;

const MonogramsLogoIdeas = ({ refCtxId }) => {
    useEffectOnce(() => {
        monitor.trackPageView();
        reportPageView();
    });

    const breadcrumbsParams = {
        list: getBreadcrumbList({
            type: 'monograms',
            name: 'Monogram Logo',
            isMonogramHubPage: true,
        }),
        theme: Breadcrumbs.THEMES.DARK,
    };

    const onHeroCTAClick = () =>
        reportIdeasHubBtnClicked({
            actionType: IDEAS_HUB_ACTIONS.START_BRIEF,
            section: IDEAS_HUB_SECTIONS.HEADER_CTA,
        });

    const onMakeYourLogoStartClick = () =>
        reportIdeasHubBtnClicked({
            actionType: IDEAS_HUB_ACTIONS.START_BRIEF,
            section: IDEAS_HUB_SECTIONS.MAKE_YOUR_LOGO,
        });

    const onIdeaTagClick = ({ tagId }) =>
        reportIdeasHubBtnClicked({
            actionType: IDEAS_HUB_ACTIONS.TAG_CLICKED,
            section: IDEAS_HUB_SECTIONS.POPULAR_KEYWORDS,
            tag: tagId,
        });

    const onDesingsTileClick = (title) =>
        reportIdeasHubBtnClicked({
            actionType: IDEAS_HUB_ACTIONS.TAG_CLICKED,
            section: IDEAS_HUB_SECTIONS.INDUSTRIES,
            tag: title,
        });

    const onFooterGetStartedClick = () =>
        reportIdeasHubBtnClicked({
            actionType: IDEAS_HUB_ACTIONS.START_BRIEF,
            section: IDEAS_HUB_SECTIONS.FOOTER,
        });

    const howDoesItWorkData = {
        title: translate('logo_maker_perseus.monograms_logo_ideas.how_does_it_work.title'),
        subtitle: translate('logo_maker_perseus.monograms_logo_ideas.how_does_it_work.subtitle'),
    };

    return (
        <div className="monogram-logo-ideas">
            <MakeMyLogoButton />
            <DiscoverHero
                heroImageUrl={HERO_IMG_URL}
                breadcrumbsParams={breadcrumbsParams}
                titlePrefix="logo_maker_perseus.monograms_logo_ideas.hero.title"
                descriptionPrefix="logo_maker_perseus.monograms_logo_ideas.hero.description"
                onMakeYourLogoClick={onHeroCTAClick}
            />
            <DesignsByIndustry
                titlePrefix="logo_maker_perseus.monograms_logo_ideas.logo_designs.title"
                industriesPrefix="logo_maker_perseus.monograms_logo_ideas.logo_designs.industries"
                desingsTiles={DESIGNS_BY_INDUSTRY}
                onTileClick={onDesingsTileClick}
            />
            <DiscoverIdeasMakeYourLogo onStartClick={onMakeYourLogoStartClick} />
            <HowDoesItWork
                className="inner max-width-container"
                sectionsKey={SECTION_KEYS.IDEAS}
                i18nPrefix="logo_maker_perseus.monograms_logo_ideas"
                isMobileOrTablet={false}
                ideasData={howDoesItWorkData}
            />
            <IdeaTags
                onClick={onIdeaTagClick}
                tags={POPULAR_KEYWORDS}
                title={<I18n k="logo_maker_perseus.discover_logo_ideas.popular_keywords.title" />}
                refCtxId={refCtxId}
            />
            <Teaser
                className="inner max-width-container"
                sections={TEASER_CONTENT}
                i18nPrefix="logo_maker_perseus.buyer_landing_page"
            />
            <Footer
                onSubmit={onFooterGetStartedClick}
                footerTitle={<I18n k={'logo_maker_perseus.discover_logo_ideas.footer.title'} />}
            />
        </div>
    );
};
MonogramsLogoIdeas.propTypes = {
    refCtxId: string,
};

export default MonogramsLogoIdeas;
